import { render } from "./Edit.vue?vue&type=template&id=d55ee88e"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/AreaProjects/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d55ee88e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d55ee88e', __exports__)) {
    console.log('reload')
    api.reload('d55ee88e', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=d55ee88e", () => {
    console.log('re-render')
    api.rerender('d55ee88e', render)
  })

}


export default __exports__